import { useCallback } from 'react';

import request from 'lib/request';

interface Response {
  code: number;
  data: Data;
  msg: string;
}

export interface Data {
  oauth_url: string;
}

export function useGetSocialOAuth() {
  const twitterOauth = useCallback(async (scope?: string) => {
    const res = await request<Response>('/user_profile/twitter_oauth_url', {
      params: {
        redirect_url: location.href,
        scope,
      },
    });
    if (res?.data?.oauth_url) {
      location.href = res?.data?.oauth_url;
      localStorage.setItem('socialOauth', 'TWITTER');
    }
  }, []);

  const discordOauth = useCallback(async () => {
    const res = await request<Response>('/user_profile/discord_oauth_url', {
      params: {
        redirect_url: location.href,
      },
    });
    if (res?.data?.oauth_url) {
      location.href = res?.data?.oauth_url;
      localStorage.setItem('socialOauth', 'DISCORD');
    }
  }, []);

  return { twitterOauth, discordOauth };
}
